import * as React from 'react';
import { CreditCardFormState, CreditCardState } from './states/CreditCardFormState';
import './cardInput.module.scss';
import { BrandIcon } from '../../../../mainv2/containers/common/payment/CardSummaryView';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { observer } from 'mobx-react';
import { VerticalStringInput, FormError } from '../../../../commonv3/components/atoms/forms/vertical';
import { StringInput } from '../../../../commonv3/components/atoms/forms/primitive/StringInput';

type FormProps = {
    formState: CreditCardFormState;
    resettable?: boolean;
    onResetRequest?: () => any;
};

@observer
export class CardInput extends React.Component<FormProps> {
    formatCcNumber(value) {
        const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
        const matches = v.match(/\d{4,16}/g);
        const match = (matches && matches[0]) || '';
        var parts = [];
        var i, len;
        for (i = 0, len = match.length; i < len; i += 4) {
            parts.push(match.substring(i, i + 4));
        }
        if (parts.length) {
            return parts.join(' ');
        } else {
            return value;
        }
    }
    handleChange(value, state) {
        const cc_number = value.replace(/\s+/g, '');
        state.setDirtyValue(cc_number);
    }
    render() {
        const { formState, resettable = false, onResetRequest = undefined } = this.props;
        const { number, yy, mm, cvc } = formState.fields;
        return (
            <div styleName="form">
                <div>
                    <BrandIcon styleName="brand-icon" brand="visa" />
                    <BrandIcon styleName="brand-icon" brand="master" />
                    <BrandIcon styleName="brand-icon" brand="american" />
                    <BrandIcon styleName="brand-icon" brand="diners" />
                    <BrandIcon styleName="brand-icon" brand="jcb" />
                </div>
                <div styleName="form-row">
                    <div>
                        <div styleName="label">カード番号</div>
                        <StringInput
                            id="card_number"
                            styleName="input"
                            value={this.formatCcNumber(number.getDirtyValue())}
                            error={number.hasErrors()}
                            type="text"
                            placeholder="例：1234 1234 1234 1234"
                            onChange={(e) => this.handleChange(this.formatCcNumber(e), number)}
                            onBlur={number.validate}
                        />
                        <FormError state={number} />
                    </div>
                </div>
                <div styleName="form-row">
                    <div styleName="label">有効期限</div>
                    <div styleName="form-row-body">
                        <div styleName="input-wrapper">
                            <StringInput
                                id="expiry_month"
                                styleName="input"
                                value={mm.getDirtyValue()}
                                error={mm.hasErrors()}
                                type="text"
                                placeholder="月（MM）"
                                onChange={mm.setDirtyValue}
                                onBlur={mm.validate}
                            />
                        </div>
                        <div styleName="input-wrapper">
                            <StringInput
                                id="expiry_year"
                                styleName="input"
                                value={yy.getDirtyValue()}
                                error={yy.hasErrors()}
                                type="text"
                                placeholder="年（YY）"
                                onChange={yy.setDirtyValue}
                                onBlur={yy.validate}
                            />
                        </div>
                    </div>
                </div>
                <div styleName="form-row">
                    <div styleName="form-row-body">
                        <div styleName="input-wrapper">
                            <FormError state={mm} />
                        </div>
                        <div styleName="input-wrapper">
                            <FormError state={yy} />
                        </div>
                    </div>
                </div>
                <div styleName="form-row">
                    <div styleName="label">セキュリティコード</div>
                    <div styleName="form-row-body">
                        <div styleName="input-wrapper security">
                            <StringInput
                                id="cvc"
                                styleName="input"
                                value={cvc.getDirtyValue()}
                                error={cvc.hasErrors()}
                                type="text"
                                placeholder="例：123"
                                onChange={cvc.setDirtyValue}
                                onBlur={cvc.validate}
                            />
                        </div>
                        <FormError state={cvc} />
                        {resettable && (
                            <Button styleName="button" type="normal" size="s" onClick={onResetRequest}>
                                戻る
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export const CardSummary = ({
    card,
    modifiable = false,
    onModifyRequest = () => null,
    styleName = undefined,
    className = undefined,
}) => (
    <div styleName="card-summary" className={className}>
        <div styleName="summary-main">
            <BrandIcon styleName="brand-icon" brand={card.brand} />
            <div styleName="number-mask">
                {'●'.repeat(4)} {'●'.repeat(4)} {card.last4}
            </div>
        </div>
        {modifiable && (
            <Button type="normal" size="s" onClick={onModifyRequest}>
                変更する
            </Button>
        )}
    </div>
);

type Props = {
    cardState: CreditCardState;
};
@observer
export class CreditCardInput extends React.Component<Props> {
    render() {
        const {
            cardState: { editMode, cardFormState, card, setEditMode },
        } = this.props;
        if (editMode) {
            return (
                <CardInput formState={cardFormState} resettable={!!card} onResetRequest={() => setEditMode(false)} />
            );
        }
        if (!card) {
            return null;
        }
        return <CardSummary card={card} modifiable={true} onModifyRequest={() => setEditMode(true)} />;
    }
}
